import { ConfigOption } from '@ngx-formly/core';
import { FormlyPasswordComponent } from './types/formly-password-component';
import { FormlyCountryComponent } from './types/formly-country-component';
import { FormlyCountryMultiSelectComponent } from './types/formly-country-multi-select-component';
import { FormlyPhoneComponent } from './types/formly-phone-component';
import { FormlyDatePickerComponent } from './types/formly-datepicker-component';
import { FormlyTextareaComponent } from './types/formly-textarea-component';
import { FormlyWrapperFormField } from './form-field/form-field.wrapper';
import { FormlyFieldInput } from './types/formly-input-component';
import { FormlyFieldCheckbox } from './types/formly-checkbox-component';
import { FormlyFieldRadio } from './types/formly-radio-component';
import { FormlyOtpComponent } from './types/formly-otp-component';
import { FormlyFieldSelect } from './types/formly-select-component';
import { FormlyButtonComponent } from './types/formly-button-component';
import { FormlyEmailWithOtpComponent } from './types/formly-email-with-otp-component';
import { EmailWithOtpValidator } from './validators/email-with-otp.validator';
import { JsonValidator } from './validators/json.validator';
import { SetupFeeValidator } from './validators/setup-fee.validator';
import { FormlyLabelWrapper } from './wrappers/formly-label-wrapper-component';
import { FormlyMultiSelectFieldComponent } from './types/formly-multi-select-component';
import { FormlyFieldApiSelect } from './types/formly-api-select-component';
import { FormlyJsonComponent } from './types/formly-json-component';
import { FormlyUsStateComponent } from './types/formly-us-state-component';
import { FormlyFileComponent } from './types/formly-file-component';

export const FORMLY_CONFIG: ConfigOption = {
  types: [
    {
      name: 'file',
      component: FormlyFileComponent,
      wrappers: ['form-field'],
    },
    {
      name: 'password',
      component: FormlyPasswordComponent,
      wrappers: ['form-field'],
    },
    {
      name: 'phone',
      component: FormlyPhoneComponent,
      wrappers: ['form-field'],
    },
    {
      name: 'otp',
      component: FormlyOtpComponent,
      wrappers: ['form-field'],
    },
    {
      name: 'country',
      component: FormlyCountryComponent,
      wrappers: ['form-field'],
    },
    {
      name: 'country-multi-select',
      component: FormlyCountryMultiSelectComponent,
      wrappers: ['form-field'],
    },
    {
      name: 'us-state',
      component: FormlyUsStateComponent,
      wrappers: ['form-field'],
    },
    {
      name: 'textarea',
      component: FormlyTextareaComponent,
      wrappers: ['form-field'],
    },
    {
      name: 'datepicker',
      component: FormlyDatePickerComponent,
      wrappers: ['form-field'],
    },

    // Input
    {
      name: 'input',
      component: FormlyFieldInput,
      wrappers: ['form-field'],
    },
    { name: 'string', extends: 'input' },
    {
      name: 'number',
      extends: 'input',
      defaultOptions: {
        props: {
          type: 'number',
        },
      },
    },
    {
      name: 'integer',
      extends: 'input',
      defaultOptions: {
        props: {
          type: 'number',
        },
      },
    },
    {
      name: 'json',
      component: FormlyJsonComponent,
      wrappers: ['form-field'],
    },

    // Checkbox
    {
      name: 'checkbox',
      component: FormlyFieldCheckbox,
      wrappers: ['form-field'],
    },
    {
      name: 'boolean',
      extends: 'checkbox',
    },

    // Radio
    {
      name: 'radio',
      component: FormlyFieldRadio,
      wrappers: ['form-field'],
    },

    // Api Select
    {
      name: 'api-select',
      component: FormlyFieldApiSelect,
      wrappers: ['form-field'],
    },

    // Select
    {
      name: 'select',
      component: FormlyFieldSelect,
      wrappers: ['form-field'],
    },

    // Multiselect
    {
      name: 'multi-select',
      component: FormlyMultiSelectFieldComponent,
      wrappers: ['form-field'],
    },

    // Button
    {
      name: 'button',
      component: FormlyButtonComponent,
    },

    // Email with otp
    {
      name: 'email-otp',
      component: FormlyEmailWithOtpComponent,
      wrappers: ['form-field'],
    },
  ],
  wrappers: [
    { name: 'form-field', component: FormlyWrapperFormField },
    { name: 'label', component: FormlyLabelWrapper },
  ],
  // extensions: [{ name: 'addons', extension: { onPopulate: addonsExtension } }],
  validators: [
    {
      name: 'email-with-otp',
      validation: EmailWithOtpValidator,
    },
    {
      name: 'json-format',
      validation: JsonValidator,
    },
    {
      name: 'setupFeeRequiredFields',
      validation: SetupFeeValidator,
    },
  ],
  validationMessages: [
    { name: 'email', message: emailError },
    {
      name: 'invalidUrl',
      message:
        'Please enter a valid URL, including the protocol (http:// or https://)',
    },
    {
      name: 'notSpecificPage',
      message:
        'Enter the full URL of the specific page that shows the information (e.g. a profile page), not a website homepage or a search results page.',
    },
    {
      name: 'searchEngineLink',
      message:
        "This is a search engine link, not the page itself. Open the result, then copy the address from your browser's address bar.",
    },
    { name: 'date', message: dateError },
    { name: 'required', message: requiredError },
    { name: 'equal', message: requiredError },
    { name: 'equalTo', message: notEqualError },
    { name: 'uniqueEmail', message: uniqueEmail },
    { name: 'validatePhone', message: phoneError },
    { name: 'url', message: urlError },
    { name: 'invalidEmailAddress', message: 'Email is not a valid email' },
    { name: 'maxlength', message: 'Maximum Length Exceeded' },
    { name: 'minlength', message: minLengthError },
    { name: 'not_matching', message: 'Password Not Matching' },
    { name: 'dayNotAllowed', message: dayNotAllowed },
    { name: 'zipCode', message: 'ZIP code should be 5 characters' },
    { name: 'min', message: minError },
    { name: 'max', message: maxError },
    { name: 'invalidOtp', message: 'Enter email verification code' },
    { name: 'invalidPhoneNumber', message: 'The phone number is not valid.' },
    {
      name: 'json-format',
      message: 'Please enter valid JSON format. Example: {"key": "value"}',
    },
    {
      name: 'setupFeeRequiredFields',
      message: setupFeeError,
    },

    { name: 'server-error', message: errorMsg },
  ],
  extras: { lazyRender: true },
};

export function errorMsg(err: any) {
  return err.toString();
}

export function minError(err: any, field: any): string {
  return `Must be at least ${err.min}`;
}

export function maxError(err: any, field: any): string {
  return 'Must be at most ${err.max}';
}

export function uniqueEmail(err: any, field: any): string {
  return field.templateOptions.label + ' is already used!';
}

export function emailError(err: any, field: any): string {
  return field.templateOptions.label + ' is not a valid email';
}

export function dayNotAllowed(err: any, field: any): string {
  return 'Available days allowed: ' + err.join(',');
}

export function dateError(err: any, field: any): string {
  return field.templateOptions.label + ' is not a valid date';
}

export function requiredError(err: any, field: any): string {
  return field.templateOptions.label + ' is required';
}

export function phoneError(err: any, field: any): string {
  return field.templateOptions.label + ' is not a valid phone';
}

export function notEqualError(err: any, field: any): string {
  return field.templateOptions.label + ' do not match';
}

export function minLengthError(err: any, field: any): string {
  return 'Should have at least ' + err.requiredLength + ' characters.';
}

export function urlError(err: any, field: any) {
  return field.templateOptions.label + ' is not a valid url.';
}

export function setupFeeError(err: any, field: any): string {
  const currency = err.currency || 'EUR';
  const missingFields = err.missingFields || [];
  return `All setup fee fields must be filled for ${currency}: ${missingFields.join(', ')}`;
}
